<template>
  <div>
    <WarRoomPostList />
    <ClientOnly>
      <WarRoomTopicsListModal />
    </ClientOnly>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import type { MetaInfo } from 'vue-meta';
import { mapGetters } from 'vuex';
import WarRoomPostList from '@/components/partials/war-room/WarRoomPostList.vue';
import WarRoomTopicsListModal from '@/components/partials/war-room/WarRoomTopicsListModal.vue';
import { makeCanonicalUrlForPagination } from '@/components/partials/war-room/utils';
import { DESCRIPTION as DEFAULT_META_DESCRIPTION } from '~/constants/defaultMeta';
import warRoomFetchPostsMixin from '~/components/partials/war-room/warRoomFetchPostsMixin';
import { makeUrl } from '~/components/utils/browser/url';
import type { ITopic } from '~/types/common';

export default Vue.extend({
  name: 'WarRoomPostsPageTopics',
  components: {
    WarRoomPostList,
    WarRoomTopicsListModal,
  },
  mixins: [warRoomFetchPostsMixin],
  head(): MetaInfo {
    const page = this.$route.query?.page;
    const topic = this.topic as ITopic;
    const title = `${topic.seo_title || topic.name}${page ? ` | Page ${page}` : ''}`;
    const url = makeUrl(this.$route.path);
    const description = `${topic.seo_description || DEFAULT_META_DESCRIPTION}${page ? ` | Page ${page}` : ''}`;

    return {
      title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: description,
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: url,
        },
      ],
      link: [
        {
          hid: 'canonical',
          rel: 'canonical',
          href: makeCanonicalUrlForPagination({ path: this.$route.path, query: this.$route.query }),
        },
      ],
    };
  },
  computed: {
    ...mapGetters('warRoom', ['topicBySlug']),
    topic() {
      return this.topicBySlug(this.$route.params.topicSlug) as ITopic;
    },
  },
});
</script>
